<template>
  <div class="auth-wrapper text-right" >
    <div class="auth-card">
      <div class="auth-header">
        <h2>تسجيل الدخول</h2>
        <p>مرحبًا بعودتك 👋</p>
      </div>

      <form @submit.prevent="makeLogin">
        <!-- Username -->
        <div class="form-group">
          <label>اسم المستخدم</label>
          <el-select
            v-model="form.name"
            filterable
            clearable
            placeholder="اختر اسم المستخدم"
            class="full-width"
          >
            <el-option
              v-for="x in users"
              :key="x.id"
              :label="x.name"
              :value="x.name"
            />
          </el-select>
        </div>

        <!-- Password -->
        <div class="form-group">
          <label>كلمة المرور</label>
          <el-input
            type="password"
            v-model="form.password"
            placeholder="••••••••"
            @keydown.enter.native="makeLogin"
            show-password
          />
        </div>

        <!-- Button -->
        <el-button
          class="login-btn"
          type="primary"
          native-type="submit"
          :loading="false"
        >
          تسجيل دخول
        </el-button>
      </form>
    </div>
  </div>
</template>

<script>
import axiosApi from "@/plugins/axios.js";
export default {
  name: "Login",
  data: () => ({
    form: {
      name: "",
      password: null,
    },
    printerName: "",
    users: [],
    printersOptions: [],
  }),
  beforeRouteEnter(to, from, next) {
    if (localStorage.getItem("heavenDashboardToken")) {
      next({ name: "Home" });
    } else {
      next();
    }
  },

  created() {
    this.getUsers();
  },
  mounted() {
    let { remote } = require("electron");

    let webContents = remote.getCurrentWebContents();
    this.printersOptions = webContents.getPrinters();
  },
  methods: {
  

    getUsers() {
      const loading = this.$loading({
          lock: true,
          text: false,
          spinner: 'el-icon-loading',
          background: 'rgba(255,255,255,.7)',
          customClass: 'fullscreen-loading'
        });
      axiosApi.get(`/users`).then((res) => {
        this.users = res.data;
      }).finally(() => loading.close());
    },

    makeLogin() {
      // const loading = this.$vs.loading();
      const loading = this.$loading({
          lock: true,
          text: false,
          spinner: 'el-icon-loading',
          background: 'rgba(255,255,255,.7)',
          customClass: 'fullscreen-loading'
        });
      axiosApi
        .post("/login", this.form)
        .then((res) => {
          console.log(res);
          this.$store.commit("setUser", res.data.user);
          localStorage.setItem(
            "heavenDashboardUser",
            JSON.stringify(res.data.user)
          );
          localStorage.setItem("heavenDashboardToken", res.data.token);
          this.$store.commit("UpdateUserStatus", true);

          this.$notify({
            title: "مرحبا بعودتك",
            message: `تسجيل دخول ناجح `,
            type: "success",
          });

          this.$router.push("/");
                //  const { ipcRenderer } = require("electron");

      //   let p={

      //     testPrinter:true,
      //       products: [],
      //         invoice: null,
      //         kitchenPrinters: false,
      //   }
      // ipcRenderer.send("printOrder",p);
          location.reload();
        })
        .catch((error) => {
          if (error.response && error.response.status === 401) {
            this.$notify.error({
              title: "خطأ",
              message: `تأكد من اسم المستخدم وكلمة المرور`,
              type: "danger",
            });
          } else {
            this.$notify.error({
              title: "خطأ",
                           message: `تأكد من اسم المستخدم وكلمة المرور`,

              type: "danger",
            });
          }
        })
      .finally(() =>
    {
        loading.close()

    }
    );
    },
  },
};
</script>
<style >
/* ===== AUTH PAGE WRAPPER ===== */
.auth-wrapper {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #eef2ff, #f8fafc);
  font-family: 'Cairo', 'Segoe UI', Tahoma, sans-serif;
}

/* ===== LOGIN CARD ===== */
.auth-card {
  width: 100%;
  max-width: 420px;
  background-color: #ffffff;
  padding: 36px 32px;
  border-radius: 18px;
  box-shadow: 0 18px 45px rgba(0, 0, 0, 0.08);
  direction: rtl;
}

/* ===== HEADER ===== */
.auth-header {
  text-align: center;
  margin-bottom: 28px;
}

.auth-header h2 {
  font-size: 24px;
  font-weight: 700;
  color: #1f2937;
  margin: 0;
}

.auth-header p {
  margin-top: 6px;
  font-size: 14px;
  color: #6b7280;
}

/* ===== FORM GROUP ===== */
.form-group {
  margin-bottom: 20px;
}

.form-group label {
  display: block;
  margin-bottom: 8px;
  font-size: 14px;
  font-weight: 600;
  color: #374151;
}

/* ===== INPUTS ===== */
.el-input__inner,
.el-select .el-input__inner {
  height: 46px;
  border-radius: 10px;
  font-size: 14px;
  padding: 0 14px;
  transition: all 0.25s ease;
}

.el-input__inner:focus,
.el-select .el-input__inner:focus {
  border-color: #6366f1;
  box-shadow: 0 0 0 3px rgba(99, 102, 241, 0.15);
}

/* ===== SELECT ===== */
.el-select {
  width: 100%;
}

/* ===== BUTTON ===== */
.login-btn {
  width: 100%;
  height: 46px;
  margin-top: 10px;
  border-radius: 12px;
  font-size: 16px;
  font-weight: 600;
  background: linear-gradient(135deg, #6366f1, #4f46e5);
  border: none;
  color: #ffffff;
  transition: all 0.3s ease;
}

.login-btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 12px 25px rgba(79, 70, 229, 0.35);
}

/* ===== LOADING OVERLAY ===== */
.fullscreen-loading {
  background: rgba(255, 255, 255, 0.85) !important;
}

/* ===== MOBILE ===== */
@media (max-width: 480px) {
  .auth-card {
    padding: 28px 22px;
    border-radius: 14px;
  }
}


 
</style>
